export default __webpack_public_path__ + "static/media/Ballroll_00355.98d9c0eb.png";